import React, { useEffect, useState } from 'react'
import { PostType } from 'src/hook/usePosts'
import { PostLeaveModal } from '../../PostModalPublication'
import { useEditPostSubmit } from './hooks/useEditPostSubmit'
import { EditPostProps } from './editPost.types'
import EditPostModal from './components/editPostModal/editPostModal'
import EditPostSidebar from './components/editPostSidebar/editPostSidebar'
import { useEditPostState } from './hooks/useEditPostState'

const EditPost: React.FC<EditPostProps> = ({ isOpen, closeModal, post, isScheduledPosts }) => {
  const { title, richDescription, setTitle, setRichDescription, isDisabled, resetFields } =
    useEditPostState({ postTitle: post.title, postRichDescription: post.richDescription as string })

  const { handleSubmit, isLoading } = useEditPostSubmit()

  const [openLeaveModal, setOpenLeaveModal] = useState<boolean>(false)
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false)

  const handleCloseAllModal = () => {
    closeModal()
    setIsFullScreen(false)
  }

  const handleCloseModal = () => {
    setOpenLeaveModal(false)
    handleCloseAllModal()
    resetFields()
  }

  const handleLeaveModal = () => {
    if (!isDisabled) {
      setOpenLeaveModal(true)
    } else {
      handleCloseModal()
    }
  }

  const handleModalFullScreen = () => {
    setIsFullScreen(!isFullScreen)
  }

  const submitAction = () =>
    handleSubmit({
      title,
      description: richDescription as string,
      postId: post.id,
      isPinnedPost: post.isFixed || false,
      isScheduledPosts,
      onClose: handleCloseModal
    })

  const showPostMediaContainer =
    post.postType === PostType.IMAGE ||
    post.postType === PostType.VIDEO ||
    post.postType === PostType.URL

  const commonProps = {
    isOpen,
    onClose: handleLeaveModal,
    title,
    setTitle,
    description: richDescription,
    setDescription: setRichDescription,
    mentions: post?.mentions,
    submitAction,
    isLoading,
    post,
    isDisabled,
    showPostMediaContainer,
    handleModalFullScreen
  }

  useEffect(() => {
    resetFields()
  }, [post])

  return (
    <>
      {!isFullScreen ? <EditPostModal {...commonProps} /> : <EditPostSidebar {...commonProps} />}

      <PostLeaveModal
        isOpen={openLeaveModal}
        onKeepEditing={() => setOpenLeaveModal(false)}
        onClose={handleCloseModal}
      />
    </>
  )
}

export default EditPost
